import { Component, inject } from '@angular/core';
import { LoadingBtnComponent } from '../../core/shared/components/loading-btn.component';
import { NgIf } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { environment } from '../../environments/environment';
import { CrudManagementService } from '../../core/services/crud-management.service';
import { AuthService } from '../../core/services/api-endpoints.service';
import { ApiRoutes } from '../../core/shared/apiroutes';
import { IAuthApiResponse } from '../../core/library/interfaces';
import { AuthType } from '../../core/library/constants';
// import Logging from '../../core/library/logging';
// import { AuthType, IAuthApiResponse, Logging } from '../../../../shared/src/import-export';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [LoadingBtnComponent, NgIf, FormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  currentYear: number = new Date().getUTCFullYear();
  userLogin = {
    email: undefined,
    password: undefined,
  };
  isLoading = false;

  AppVer = environment.version;

  isResetingPass = false;
  isOtpSent = false;

  apiService = inject(CrudManagementService);
  apiEndpointsService = inject(AuthService);

  login(form: NgForm) {
    this.isLoading = true;
    this.apiService
      .post(ApiRoutes.login, { ...form.value, type: AuthType.Password })
      .subscribe({
        next: (value) => {
          // Logging.info('login response', value);
          const authResponse = value as IAuthApiResponse;
          if (!authResponse.error) {

            this.apiEndpointsService.setAuthUser(authResponse);
          } else {
            //do something
          }
        },
        error: (error) => {
          // Logging.error('login error', error);
        },
        complete: () => { },
      })
      .add(() => {
        this.isLoading = false;
      });
  }
  sendOtp(form: NgForm) {
    this.isLoading = true;
    this.apiService
      .post(ApiRoutes.forgotPassword, {
        ...form.value,
        type: AuthType.Password,
      })
      .subscribe({
        next: (value) => {
          // Logging.info('response', value);
          const authResponse = value as IAuthApiResponse;
          if (!authResponse.error) {
            this.isOtpSent = true;
          } else {
            //do something
          }
        },
        error: (error) => {
          // Logging.error('sendOtp error', error);
        },
        complete: () => { },
      })
      .add(() => {
        this.isLoading = false;
      });
  }
  verifyOtpResetPass(form: NgForm) {
    this.isLoading = true;
    this.apiService
      .post(ApiRoutes.resetPassword, {
        ...form.value,
        confirmPassword: form.value.password,
        type: AuthType.Password,
      })
      .subscribe({
        next: (value) => {
          // Logging.info('response', value);
          const authResponse = value as IAuthApiResponse;
          if (!authResponse.error) {
            this.isResetingPass = false;
            this.isOtpSent = false;
          } else {
            //do something
          }
        },
        error: (error) => {
          // Logging.error('sendOtp error', error);
        },
        complete: () => { },
      })
      .add(() => {
        this.isLoading = false;
      });
  }
}
